module.exports = __webpack_public_path__ + "img/168.ba79d69e.jpg";